(function ($) {
	/**
	 * initializeBlock
	 *
	 * Adds custom JavaScript to the media-list-block HTML.
	 *
	 * @date    04/05/2024
	 * @since   4.0.0
	 *
	 * @return  void
	 */
	const initializeBlock = function ($block) {
		Fancybox.bind('[data-fancybox]', {
			buttons: ['play', 'close'],
			loop: true,
			protect: true,
			placeFocusBack: false, // Prevent default focus behavior
			autoFocus: false, // Avoids autofocus-related width adjustments
			on: {
				init: (fancybox) => {
					document.body.style.paddingRight = '0'; // Ensure no width adjustments
					document.body.style.width = '100%'; // Ensure no width adjustments
				},
				destroy: (fancybox) => {
					document.body.style.paddingRight = ''; // Reset on close
					document.body.style.width = ''; // Reset on close
				},
			},
		});
		$block.find('a.page-number').on('click', function (e) {
			e.preventDefault();

			let link = $(this).attr('href');
			$.ajax({
				url: link,
				type: 'GET',
				success: function (data) {
					let posts = $(data).find('#video-wrapper').html();
					$('#video-wrapper').html(posts);

					let pagination = $(data).find('#pagination').html();
					$('#pagination').html(pagination);
					$(window).scrollTop($('#video-wrapper').offset().top);
					initializeBlock($block);
				},
			});
		});
	};

	// Initialize each block on a page load (front end).
	$(document).ready(function () {
		$('.wp-block-acf-media-list-block').each(function () {
			initializeBlock($(this));
		});
	});

	// Initialize dynamic block preview (editor).
	if (window.acf) {
		window.acf.addAction(
			'render_block_preview/type=media-list-block',
			function ($block) {
				initializeBlock($($block));
			}
		);
	}
})(jQuery);
